export async function ReadFileToStringAsync(file: File, fileType?: string): Promise<string> {
  const reader = new FileReader();

  if (fileType && file.type !== fileType) {
    console.log(`${fileType} / ${file.type}`)
    throw Error("指定された形式のファイルではありません。")
  }

  return await new Promise<string>((resolve, reject) => {
    reader.onload = () => resolve(reader.result?.toString() ?? "");
    reader.onerror = () => reject(reader.error);
    reader.readAsText(file);
  });
}

/** 読み込んだ文字列が、SVGの図形として使えるか。空のファイルや、svg要素を含まないファイルは使えない */
export function isSvgContent(content: string): boolean {
  return /<svg[\s>]/i.test(content);
}

/** SVGとして読み込んだ結果を、図形として使えるものと、使えないもの（読み込みに失敗した・中身がSVGでない）のファイル名に分ける */
export function splitSvgReadData(readData: { content: string, fileName: string, error?: unknown }[]): { valid: { content: string, fileName: string }[], invalidFileNames: string[] } {
  const valid: { content: string, fileName: string }[] = [];
  const invalidFileNames: string[] = [];
  for (const data of readData) {
    if (data.error === undefined && isSvgContent(data.content)) {
      valid.push({ content: data.content, fileName: data.fileName });
    } else {
      invalidFileNames.push(data.fileName);
    }
  }
  return { valid, invalidFileNames };
}

export async function ReadFilesToStringAsync(fileList: FileList, fileType?: string): Promise<{ content: string, fileName: string, error?: unknown }[]> {
  return Promise.all(Array.from(fileList).map(async file => {
    try {
      const content = await ReadFileToStringAsync(file, fileType);
      return { content, fileName: file.name, error: undefined };
    } catch (error) {
      return { content: "", fileName: file.name, error }
    }
  }));
}